var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNature(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.4501 40.2927C25.4501 48.7519 32.3229 55.6249 40.7593 55.6519V55.6686H40.8093C49.2852 55.6686 56.1686 48.7851 56.1686 40.3093C56.1686 31.8335 49.2852 24.95 40.8093 24.95C32.3336 24.95 25.4501 31.8169 25.4501 40.2927ZM26.3602 40.3093C26.3602 32.3351 32.8351 25.8601 40.8093 25.8601C48.7671 25.8601 55.2585 32.3351 55.2585 40.3093C55.2585 48.2835 48.7835 54.7584 40.8093 54.7584C32.8351 54.7584 26.3602 48.2835 26.3602 40.3093Z",
    fill: "#343333",
    stroke: "#343333",
    strokeWidth: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51.0596 30.0425H30.5591V50.543H51.0596V30.0425Z",
    stroke: "#343333",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7946 25.7973L26.2985 40.2934L40.7946 54.7895L55.2907 40.2934L40.7946 25.7973Z",
    stroke: "#343333",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M72.208 44.5571H72.2083H72.2248C72.9321 44.5571 73.5895 44.2897 74.0948 43.7886C74.5998 43.2878 74.8865 42.6195 74.8865 41.9172V38.6882C74.8865 37.2346 73.7071 36.0484 72.2415 36.0483C72.2415 36.0483 72.2414 36.0483 72.2414 36.0483L55.3156 35.95L55.2375 35.9495L55.2698 36.0207L55.7109 36.9927L55.2663 43.7362L54.8277 44.3806L54.7749 44.4582L54.8687 44.4587L72.208 44.5571Z",
    fill: "#343333",
    stroke: "#343333",
    strokeWidth: 0.1
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.62845 44.5571L8.62817 44.5571L8.61165 44.5571C7.90434 44.5571 7.24701 44.2897 6.74168 43.7886C6.23668 43.2878 5.95001 42.6195 5.95001 41.9172L5.95 38.6882C5.95 37.2346 7.12935 36.0484 8.59497 36.0484C8.59502 36.0484 8.59506 36.0484 8.59511 36.0484L25.9672 35.95L26.0175 35.9497L26.0175 36L26.0175 36.9835L26.0176 36.9835L26.0174 36.9868L25.5722 43.7392L26.0088 44.3806L26.0616 44.4582L25.9678 44.4587L8.62845 44.5571Z",
    fill: "#343333",
    stroke: "#343333",
    strokeWidth: 0.1
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8019 40.129C56.3019 39.129 54.302 44.129 55.8019 48.629C57.3019 48.7957 60.7019 48.529 62.3019 46.129C63.9019 43.729 63.3019 41.129 62.8019 40.129Z",
    fill: "white",
    stroke: "#343333"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M63.54 38.4727C64.54 31.9727 59.54 29.9727 55.04 31.4727C54.8734 32.9727 55.14 36.3727 57.54 37.9727C59.94 39.5727 62.54 38.9727 63.54 38.4727Z",
    fill: "white",
    stroke: "#343333"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8671 39.54C25.3671 40.54 27.3671 35.54 25.8671 31.04C24.3671 30.8734 20.9671 31.14 19.3671 33.54C17.7671 35.94 18.3671 38.54 18.8671 39.54Z",
    fill: "white",
    stroke: "#343333"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M18.129 41.1963C17.129 47.6963 22.129 49.6963 26.629 48.1963C26.7957 46.6963 26.529 43.2964 24.129 41.6964C21.729 40.0964 19.129 40.6963 18.129 41.1963Z",
    fill: "white",
    stroke: "#343333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNature);
export default __webpack_public_path__ + "static/media/Nature.417e82acbe75de57405a5a6635aaa2bc.svg";
export { ForwardRef as ReactComponent };